import { render } from "./baremo_operarios.vue?vue&type=template&id=4f110e18"
import script from "./baremo_operarios.vue?vue&type=script&lang=js"
export * from "./baremo_operarios.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__